import Difficulty from "src/icons/Difficulty";
import Difficulty1 from "src/icons/Difficulty-1";
import Difficulty2 from "src/icons/Difficulty-2";
import Difficulty3 from "src/icons/Difficulty-3";
import Difficulty4 from "src/icons/Difficulty-4";
import { VariantDifficulty } from "src/types/VariantDifficulty";

function getDifficultyIcon(difficulty: VariantDifficulty) {
  return (function () {
    switch (difficulty) {
      case `beginner`:
        return <Difficulty1 />;
      case `moderate`:
        return <Difficulty2 />;
      case `intermediate`:
        return <Difficulty3 />;
      case `advanced`:
        return <Difficulty4 />;
      default:
        return <Difficulty />;
    }
  })();
}

export default getDifficultyIcon;
